import {ApplicationConfig, provideZoneChangeDetection} from '@angular/core';
import {provideRouter, RouteReuseStrategy} from '@angular/router';

import {routes} from './app.routes';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {ServerURLInterceptor} from './server.url.interceptor';
import {provideAnimations} from '@angular/platform-browser/animations';
import {provideNzI18n, zh_CN} from 'ng-zorro-antd/i18n';
import {EchUtils} from './ech-utils/ech-utils';
import {AppRouteReuseStrategy} from './AppRouteReuseStrategy';
import {PermissionService} from './permission.service';
import {registerLocaleData} from '@angular/common';
import zh from '@angular/common/locales/zh';
import {ImgServerService} from "./img.server/img.server.service";
import {PinyinService} from "./pinyin/pinyin.service";
import {register} from 'swiper/element/bundle';

register();
registerLocaleData(zh);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideHttpClient(withInterceptors([ServerURLInterceptor])),
    provideRouter(routes),
    provideAnimations(),
    provideNzI18n(zh_CN),
    {provide: RouteReuseStrategy, useClass: AppRouteReuseStrategy},
    {provide: EchUtils, useClass: EchUtils},
    {provide: PermissionService, useClass: PermissionService},
    {provide: ImgServerService, useClass: ImgServerService},
    {provide: PinyinService, useClass: PinyinService},
  ]
};
